import { Form, message, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { forgetPassword } from "../../api";
import { getSubdomain } from "utils";
import SharedPhoneInput from "components/shared/PhoneNumInpt";
import { changeLanguage } from "utils";
import LoginBrandLogo from "modules/auth/components/login/LoginBrandLogo";

const ForgetPass = ({ setPage, setData }) => {
  const { t, i18n } = useTranslation();
  const subdomain = getSubdomain();
  const isDark = +localStorage.getItem("isDark");
  const [form] = Form.useForm();

  const handleModeClick = () => {
    localStorage.setItem("isDark", isDark ? 0 : 1);
    window.location.reload();
  };

  const changeLng = () =>
    changeLanguage(i18n, i18n.language === "ar" ? "en" : "ar");

  const handleSubmit = async (values) => {
    const mobile = values.mobile;

    try {
      const res = await forgetPassword({ mobile, slug: subdomain });
      if (res.status) {
        message.success(t("code_sent"));
        setPage(2);
        setData((prev) => ({ ...prev, mobile }));
      } else {
        // A send-cooldown refusal carries the seconds left as errors[0], not a sentence.
        const firstError =
          (typeof res?.errors?.[0] === "string" && res.errors[0]) ||
          res?.message ||
          t("somethingWentWrong");
        form.setFields([{ name: "mobile", errors: [firstError] }]);
      }
    } catch (error) {
      message.error(t("somethingWentWrong"));
    }
  };

  return (
    <section className="flex flex-col lg:flex-row items-stretch relative min-h-screen h-auto lg:h-screen">
      <div className="absolute top-[32px] z-[60] end-[16px] lg:end-[calc(48%+16px)] inline-flex items-center gap-2">
        <div
          className={`
            w-9 h-9 p-1 rounded-[20px] border
            inline-flex justify-center items-center cursor-pointer
            ${isDark ? "bg-slate-900 border-slate-800" : "bg-surface border-border-light"}
          `}
          onClick={handleModeClick}
        >
          <img
            src={isDark ? "/icons/sun.svg" : "/icons/moon.svg"}
            alt="toggle mode"
          />
        </div>
        <Tooltip title={i18n.language === "ar" ? "English" : "عربي"}>
          <div
            className={`
            w-9 h-9 p-1 rounded-[20px] border
            inline-flex justify-center items-center cursor-pointer
            ${isDark ? "bg-slate-900 border-slate-800" : "bg-surface border-border-light"}
          `}
            onClick={changeLng}
          >
            <img
              src={
                isDark ? "/icons/mlti-lang-dark.svg" : "/icons/mlti-lang.svg"
              }
              alt="toggle language"
              className="w-5 h-5"
            />
          </div>
        </Tooltip>
      </div>

      <LoginBrandLogo isDark={isDark} />
      <div
        className={`w-full lg:w-[52%] flex flex-col justify-center px-4 sm:px-8 lg:px-[72px] py-8 lg:py-0 lg:h-full pb-[70px] ${
          isDark ? "bg-chrome" : "bg-surface"
        }`}
      >
        <h1
          className={`text-xl sm:text-2xl lg:text-[24px] font-bold mt-6 mb-2.5 leading-6 sm:leading-8 ${
            isDark ? "login-text-color" : "text-brand"
          }`}
        >
          {t("login.forget_password")}
        </h1>

        <span
          className={`text-sm inline-block ${
            isDark ? "text-[#B4B4B4]" : "text-[#737373]"
          }`}
        >
          {t("login.input")}
        </span>

        <Form
          form={form}
          className="w-full max-w-md lg:max-w-lg mt-8"
          onFinish={handleSubmit}
        >
          <SharedPhoneInput name="mobile" form={form} required />
          <button
            type="submit"
            className="bg-brand hover:bg-brand/90 rounded-lg flex items-center justify-center w-full h-[48px] sm:h-[56px] text-surface font-semibold mt-8 text-sm sm:text-base duration-200"
          >
            {t("login.send")}
          </button>
          <Link
            to={"/login"}
            className={`rounded-lg flex items-center justify-center w-full h-[48px] sm:h-[56px] font-semibold mt-[14px] text-sm sm:text-base border duration-200 ${
              isDark
                ? "bg-transparent hover:bg-surface/10 text-[#F6F6F6] border-[#F6F6F6]"
                : "bg-transparent hover:bg-gray-100 text-[#737373] border-[#E0E0E0]"
            }`}
          >
            {t("login.back_login")}
          </Link>
        </Form>
      </div>

      <div
        className="relative w-full lg:w-[48%] min-h-[400px] lg:h-full bg-no-repeat bg-center order-first lg:order-last login-bg-image"
        style={{
          backgroundImage: "url('/login-img.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="lg:hidden absolute inset-0 z-50 flex items-center justify-center"></div>
      </div>
    </section>
  );
};

export default ForgetPass;
